import { InputPropertyValue } from "./InputPropertyValue";
import type { PropertyValueProps } from "./types";

export const NumericPropertyValue = (props: PropertyValueProps) => (
	<InputPropertyValue {...props} inputType="decimal" placeholder="enter-number" />
);
